var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMala(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#02404F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.1,6.8h-2.5v-4C21,2.5,21.3,2,21.3,1.5c0-0.8-0.7-1.5-1.5-1.5h-5.7c-0.8,0-1.5,0.7-1.5,1.5 c0,0.5,0.3,1,0.7,1.3v4h-2.5c-2,0-3.6,1.6-3.6,3.6v16.9c0,1.7,1.2,3.1,2.8,3.5c-0.3,0.4-0.4,0.8-0.4,1.3c0,1.2,0.9,2.1,2.1,2.1 c1.2,0,2.1-0.9,2.1-2.1c0-0.4-0.1-0.8-0.4-1.2h6.9c-0.2,0.3-0.4,0.7-0.4,1.2c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1 c0-0.5-0.2-0.9-0.4-1.3c1.6-0.4,2.8-1.8,2.8-3.5V10.3C26.6,8.3,25,6.8,23.1,6.8z M14.2,1.4h5.7c0,0,0,0,0,0c0,0,0,0,0,0L14.2,1.4 C14.1,1.5,14.1,1.5,14.2,1.4C14.1,1.5,14.1,1.4,14.2,1.4z M14.9,2.9h4.2v3.8h-4.2V2.9z M11.8,32.6c-0.4,0-0.6-0.3-0.6-0.6 c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6C12.5,32.3,12.2,32.6,11.8,32.6z M22.2,32.6c-0.4,0-0.6-0.3-0.6-0.6 c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6C22.8,32.3,22.5,32.6,22.2,32.6z M25.2,27.2c0,1.2-0.9,2.1-2.1,2.1H10.9 c-1.2,0-2.1-0.9-2.1-2.1V10.3c0-1.2,0.9-2.1,2.1-2.1h12.1c1.2,0,2.1,0.9,2.1,2.1V27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,9.4c-0.4,0-0.7,0.3-0.7,0.7v17.2c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V10.1 C12.5,9.7,12.2,9.4,11.8,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,9.4c-0.4,0-0.7,0.3-0.7,0.7v17.2c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V10.1 C16,9.7,15.7,9.4,15.3,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,9.4c-0.4,0-0.7,0.3-0.7,0.7v17.2c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V10.1 C19.5,9.7,19.1,9.4,18.7,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.2,9.4c-0.4,0-0.7,0.3-0.7,0.7v17.2c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V10.1 C22.9,9.7,22.6,9.4,22.2,9.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMala);
export default __webpack_public_path__ + "static/media/Mala.e489a0ed78e06c0fe9d3f95d6aeea8ae.svg";
export { ForwardRef as ReactComponent };